import compact from 'lodash/compact';
import React, {useState} from 'react';
import { ChevronDown } from 'react-feather';
import classnames from 'classnames';

import StrapiLinkUnstyled from '../StrapiLink/StrapiLinkUnstyled';
import { NavigationItemComponentFragment } from '../../../graphql.schema';
import { NavigationLink } from '../NavigationLink/NavigationLink';

import * as styles from './navigation-dropdown.module.scss';

type NavigationDropdownProps = {
  item: NavigationItemComponentFragment;
  className?: string;
};

const DropdownContent: React.FC = (props) => {
  
  return (
  <>
  <div onClick={props.handledropdown}>
    {props.children}
    </div>
  </>
  )
  };

export const NavigationDropdown = ({ item, className }: NavigationDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  if (!item.childLinks?.length) {
    return null;
  }

  return (
    <div className={classnames('navbar-item has-dropdown is-hoverable', className)}>
      {item.link ? (
        <>
        <div className={classnames(styles.dropdownheader)}>
        <StrapiLinkUnstyled {...item.link} className="navbar-item is-text-2">
          <DropdownContent handledropdown={handleOpen}>{item.title}</DropdownContent>
        </StrapiLinkUnstyled>
        <span className={styles.chevron} 
          onClick={handleOpen}
        >
          <ChevronDown size={16} />
        </span>
        </div>
        </>
      ) : (
        <>
        <div className={classnames(styles.dropdownheader)}>
        <span className={classnames('navbar-item is-text-2', styles.groupLink)}>
          <DropdownContent handledropdown={handleOpen}>{item.title}</DropdownContent>
        </span>
        <span className={styles.chevron} 
          onClick={handleOpen}
        >
          <ChevronDown size={16} />
        </span>
        </div>
        </>
      )}
      <div className={classnames('navbar-dropdown', isOpen ? styles.navbardropdown : styles.dropdown, className)}>
        {compact(item.childLinks).map((link) => (
          <NavigationLink key={`navigation-link-${link.id}`} link={link} />
        ))}
      </div>
    </div>
  );
};
